"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
var get_app_insights_instance_1 = __importDefault(require("./get-app-insights-instance"));
var ApplicationInsights = /** @class */ (function () {
    function ApplicationInsights(connectionString, appInsightsEnableCorsCorrelation, appInsightsCorrelationHeaderExcludeDomains, appInsightsTracingMode) {
        if (appInsightsEnableCorsCorrelation === void 0) { appInsightsEnableCorsCorrelation = false; }
        if (appInsightsCorrelationHeaderExcludeDomains === void 0) { appInsightsCorrelationHeaderExcludeDomains = []; }
        if (appInsightsTracingMode === void 0) { appInsightsTracingMode = applicationinsights_web_1.DistributedTracingModes.W3C; }
        this.connectionString = connectionString;
        this.appInsights = (0, get_app_insights_instance_1.default)(connectionString, appInsightsEnableCorsCorrelation, appInsightsCorrelationHeaderExcludeDomains, appInsightsTracingMode);
    }
    ApplicationInsights.prototype.build = function () {
        this.appInsights.loadAppInsights();
    };
    ApplicationInsights.prototype.pageView = function (path) {
        var location = {
            name: path,
        };
        this.appInsights.trackPageView(location);
    };
    ApplicationInsights.prototype.event = function (action, category) {
        var event = {
            name: action,
        };
        var customProps = {
            category: category,
            url: window.location.origin,
        };
        this.appInsights.trackEvent(event, customProps);
    };
    ApplicationInsights.prototype.dimensionEvent = function (action, category, label, value) {
        var event = {
            name: action,
        };
        var customProps = {
            category: category,
            url: window.location.origin,
            label: label,
            value: value,
        };
        this.appInsights.trackEvent(event, customProps);
    };
    ApplicationInsights.prototype.customEvent = function (name, info) {
        var event = {
            name: name,
        };
        var customProps = __assign({}, info);
        this.appInsights.trackEvent(event, customProps);
    };
    ApplicationInsights.prototype.trace = function (message) {
        var trace = {
            message: message,
        };
        this.appInsights.trackTrace(trace);
    };
    ApplicationInsights.prototype.isEnabled = function () {
        return !!this.connectionString;
    };
    ApplicationInsights.prototype.eventData = function (data) {
        var name = typeof data.event === "string" ? data.event : "customEvent";
        var event = {
            name: name,
        };
        this.appInsights.trackEvent(event, data);
    };
    return ApplicationInsights;
}());
exports.default = ApplicationInsights;
